// api.service.ts

import {
  HttpClient,
} from '@angular/common/http';

import {
  Injectable,
} from '@angular/core';

import {
  Observable,
} from 'rxjs';

import {
  retryWithBackoff,
} from './retry.strategy';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  constructor(
    private http: HttpClient
  ) {}

  // =====================================
  // GET
  // =====================================

  get<T>(
    host: string,
    endpoint: string,
    options: any = {}
  ): Observable<any> {

    return this.http
      .get(
        `${host}${endpoint}`,
        options
      )
      .pipe(
        retryWithBackoff(0, 1000)
      );

  }

  // =====================================
  // POST
  // =====================================

  post<T>(
    host: string,
    endpoint: string,
    body: any,
    options: any = {}
  ): Observable<any> {

    return this.http
      .post(
        `${host}${endpoint}`,
        body,
        options
      )
      .pipe(
        retryWithBackoff(0, 1000)
      );

  }

  // =====================================
  // PUT
  // =====================================

  put<T>(
    host: string,
    endpoint: string,
    body: any,
    options: any = {}
  ): Observable<any> {

    return this.http
      .put(
        `${host}${endpoint}`,
        body,
        options
      )
      .pipe(
        retryWithBackoff(0, 1000)
      );

  }

}